module.exports = __webpack_public_path__ + "img/reply-all.00c62ddb.png";